<pbc-sorter [config]="ArchivSorterConfig" [sorter]="archiv.sorter$ | async" (sorterChange)="archiv.sorter$.next($event)"></pbc-sorter>
